import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectBulkUpdateCustomAttribute, selectModalBulkUpdateField, selectSelected } from 'store/Contextualization/AssetDetail/selectors';
import { selectCurrentWorkspace, selectWorkspaces } from 'store/Faraday/selectors';
import selectModal from 'store/modals/selectors';
import { MODAL_MANAGE_BULK_UPDATE } from 'store/modals/modals';
import { setBulkUpdateValue, setBulkUpdateField } from 'store/Contextualization/AssetDetail/actions';
import get from 'lodash/get';
import BulkTitle from './components/BulkTitle';
import SubmitButtons from './components/SubmitButtons';
import { ModalContent, Wrapper, EditorWrapper } from './styled';
import BULK_UPDATE_COMPONENTS from './components/components';
import {
  BulkDescription,
  NameGroupingWarning
} from 'Screens/Contextualization/Manage/components/ManageTable/components/BulkUpdateModal/styled';
import { useIntl } from 'react-intl';
import { isWorkspaceGroupedByName } from 'Common/Functions/vulnerabilityNameEdit';

const BulkUpdateModal = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const bulkUpdateField = useSelector(selectModalBulkUpdateField);
  const showModal = useSelector((state) => selectModal(state, MODAL_MANAGE_BULK_UPDATE));
  const vulnsSelected = useSelector((state) => selectSelected('vulns', state));
  const selectedVulnsCount = vulnsSelected.length;
  const customAttribute = useSelector(selectBulkUpdateCustomAttribute);
  const currentWorkspace = useSelector(selectCurrentWorkspace);
  const workspaces = useSelector(selectWorkspaces);
  const field = bulkUpdateField === 'custom_fields' ? get(customAttribute, 'field_type', '') : bulkUpdateField;
  const bulkUpdateComponent = get(BULK_UPDATE_COMPONENTS, field, null);
  const showSubmitButtons = bulkUpdateField !== 'comment';
  const showNameGroupingWarning = (
    bulkUpdateField === 'name' &&
    isWorkspaceGroupedByName(currentWorkspace, workspaces)
  );

  useEffect(() => () => {
    dispatch(setBulkUpdateValue(''));
    dispatch(setBulkUpdateField(''));
  }, [dispatch]);

  if (!showModal) return null;
  return (
    <Wrapper>
      <ModalContent>
        <BulkTitle />
        {showNameGroupingWarning && (
          <NameGroupingWarning>
            This vulnerability belongs to a workspace where “Group by Similarity Name” is enabled.
            {' '}
            Renaming it may trigger automatic regrouping with similar vulnerabilities.
          </NameGroupingWarning>
        )}
        { selectedVulnsCount > 1 && <BulkDescription>{ intl.formatMessage({ id: 'vulns.edit.description' }) }</BulkDescription> }
        <EditorWrapper isBulk={ selectedVulnsCount > 1 }>
          { bulkUpdateComponent }
        </EditorWrapper>
        { showSubmitButtons && <SubmitButtons /> }
      </ModalContent>
    </Wrapper>
  );
};

export default BulkUpdateModal;
